function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useMemo } from "react";
import CloseIcon from "@pixel/assets/icons/Close";
import FullscreenIcon from "@pixel/assets/icons/Fullscreen";
import FullscreenExitIcon from "@pixel/assets/icons/FullscreenExit";
import IconButton from "../IconButton";
import Button from "../Button";
import { useTheme } from "../styles";
import DialogContent from "../DialogContent";
import DialogActions from "../DialogActions";
import DialogTitle from "../DialogTitle";
import Dialog from "../Dialog";
import Box from "../Box";
const autoscrollStyle = {
  "& .MuiDialogContent-root": {
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    overflowY: "scroll"
  },
  "& .MuiPaper-rounded": {
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    overflowY: "scroll"
  },
  "& .MuiDialogContent-root::-webkit-scrollbar": {
    display: "none"
  },
  "& .MuiPaper-rounded::-webkit-scrollbar": {
    display: "none"
  }
};
export const ContentModal = _ref => {
  let {
    rejectActions = [{
      reason: "cancel",
      label: "Cancel"
    }],
    resolveActions = [{
      reason: "ok",
      label: "OK"
    }],
    id = "modal",
    labelCloseAria = "Close",
    open = false,
    sizeVariant = "md",
    showClose = true,
    onClose = () => {},
    onExited = () => {},
    onEntered = () => {},
    onReject = () => {},
    onResolve = () => {},
    autoscroll = true,
    makeFullScreen = false,
    disableEnforceFocus = false,
    modalProps = {},
    ...props
  } = _ref;
  const {
    title,
    children,
    renderTitle
  } = props;
  const theme = useTheme();
  const [isFullscreen, setIsFullscreen] = React.useState(false);
  const openContentFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };
  const handleReject = reason => {
    onReject(reason);
    onClose();
  };
  const handleResolve = reason => {
    const shouldCancelClose = onResolve(reason);
    if (shouldCancelClose) {
      return;
    }
    onClose();
  };
  const handleExited = () => {
    onExited();
  };
  const outputTitle = useMemo(() => /*#__PURE__*/React.createElement(Box, {
    mr: showClose ? 12 : 9,
    sx: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }, title), [title]);
  const isRenderTitleFunction = Boolean(renderTitle) && typeof renderTitle === "function";
  const hasRejectActions = Boolean(rejectActions) && rejectActions.length >= 1;
  const hasResolveActions = Boolean(resolveActions) && resolveActions.length >= 1;
  const handleClose = (event, reason) => {
    if (reason && !showClose && reason === "backdropClick") {
      return;
    }
    if (hasRejectActions) {
      handleReject(undefined);
    } else {
      handleResolve(undefined);
    }
  };
  const renderActionButton = (index, action, isResolve) => {
    const handler = isResolve ? () => {
      handleResolve(action.reason);
      setIsFullscreen(false);
    } : () => {
      handleReject(action.reason);
      setIsFullscreen(false);
    };
    const autoFocus = isResolve && index === resolveActions.length - 1;
    return /*#__PURE__*/React.createElement(Button, {
      key: action.label,
      disabled: action.disabled || false,
      variant: isResolve === true ? "contained" : "outlined",
      autoFocus: autoFocus,
      color: "primary",
      onClick: handler
    }, action.label);
  };
  return /*#__PURE__*/React.createElement(Dialog, _extends({
    fullScreen: isFullscreen,
    open: open,
    onClose: handleClose,
    "aria-labelledby": title,
    id: "".concat(id, "-dialog-wrapper"),
    disableEscapeKeyDown: !showClose,
    disableEnforceFocus: disableEnforceFocus,
    maxWidth: sizeVariant,
    TransitionProps: {
      onExited: handleExited,
      onEntered
    },
    sx: {
      zIndex: 1200,
      ...props.style,
      ...(autoscroll === false && autoscrollStyle)
    }
  }, modalProps), /*#__PURE__*/React.createElement(DialogTitle, {
    variant: "h3",
    id: "".concat(id, "-dialog-title"),
    sx: {
      backgroundColor: theme.palette.pixelContrast.fades.smooth
    }
  }, isRenderTitleFunction ? renderTitle(outputTitle) : outputTitle, makeFullScreen && /*#__PURE__*/React.createElement(IconButton, {
    onClick: openContentFullscreen,
    sx: {
      position: "absolute",
      right: 56,
      top: 12,
      color: theme.palette.pixelContrast.fades.medium
    }
  }, isFullscreen ? /*#__PURE__*/React.createElement(FullscreenExitIcon, null) : /*#__PURE__*/React.createElement(FullscreenIcon, null)), showClose ? /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": labelCloseAria,
    onClick: () => {
      onClose();
      setIsFullscreen(false);
    },
    sx: {
      position: "absolute",
      right: 8,
      top: 12,
      color: theme.palette.pixelContrast.fades.medium
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, null)) : null), /*#__PURE__*/React.createElement(DialogContent, {
    dividers: true,
    id: "".concat(id, "-dialog-content")
  }, /*#__PURE__*/React.createElement("div", null, children)), /*#__PURE__*/React.createElement(DialogActions, null, hasRejectActions && rejectActions.map((action, index) => renderActionButton(index, action, false)), hasResolveActions && resolveActions.map((action, index) => renderActionButton(index, action, true))));
};
export default ContentModal;